import {
  Component,
  Input,
  SimpleChanges,
  OnChanges,
  ViewEncapsulation,
  ChangeDetectorRef,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { FlexBaseComponent } from '@wephone-core-ui';
import { LiveUserStatusEntity } from '@wephone-core/model/entity/live-user-status';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { IUserEntity } from '@wephone-core/model/entity/user.i';
import { PeriodPerformance, SingleUserStatsQoSData, UserService } from '@wephone/services/user.service';
import { AgentService, IDailyStats } from '@wephone/services/agent.service';
import { UserGroupEntity } from '@wephone-core/model/entity/usergroup';
import * as _ from 'lodash';
import { ConfigManager } from '@wephone-core/wephone-core.module';
import { FeatureName } from '@wephone-core/system';

@Component({
  selector: 'app-today-performance',
  templateUrl: './today-performance.component.html',
  styleUrls: ['./today-performance.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TodayPerformanceComponent extends FlexBaseComponent implements OnChanges, OnInit {
  @Input() hasLoadData = false;
  @Output() readonly onChangedPeriod: EventEmitter<PeriodPerformance> = new EventEmitter<PeriodPerformance>(null);

  currentUser: IUserEntity;
  singleUserDailyStats: SingleUserStatsQoSData;
  queueUserDailyStats: IDailyStats;

  qosGroupNames: string;
  hasFeatureGroup: boolean;
  shortQosGroupName: string;
  period: PeriodPerformance = PeriodPerformance.Today;
  periods: PeriodPerformance[] = [
    PeriodPerformance.Today,
    PeriodPerformance.ThisWeek,
    PeriodPerformance.ThisMonth
  ];

  private readonly isInitialized = false;

  constructor(
    private readonly authService: AuthenticationService,
    private readonly userService: UserService,
    private readonly agentService: AgentService,
    private readonly configManager: ConfigManager,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(cdr);
    this.currentUser = this.authService.getUser();
  }

  ngOnInit(): void {
    this.loadData();
    this.hasFeatureGroup = this.configManager.hasFeature(FeatureName.SERVICE_GROUP);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isInitialized && this.hasLoadData) {
      this.loadData();
    }
  }

  async onChangePeriod(p: PeriodPerformance): Promise<void> {
    this.period = p;
    await this.loadData();
    if (this.onChangedPeriod) {
      this.onChangedPeriod.emit(this.period);
    }
  }

  private async loadData(): Promise<any> {
    // console.log('period', this.period);
    this.singleUserDailyStats = await this.userService.getUserPerformance(this.period);

    // console.log('todayStats', this.singleUserDailyStats);

    if (!this.authService.isUser()) {
      this.queueUserDailyStats = await this.agentService.queueUserDailyStats(this.period);
    }

    this.updateQosGroupName();
    this.cdr.detectChanges();
  }

  updateQosGroupName(): void {
    if (!this.currentUser) {
      return;
    }
    const serviceGroupNameList = this.currentUser.agent.service_group_list.filter((g: UserGroupEntity) => !g.parent_id).map((g: UserGroupEntity) => g.name);
    this.qosGroupNames = serviceGroupNameList.join(', ');
    if (serviceGroupNameList.length > 2) {
      serviceGroupNameList.splice(2);
      serviceGroupNameList.push('...');
    }
    this.shortQosGroupName = serviceGroupNameList.join(', ');
  }
}
